module.exports = __webpack_public_path__ + "static/media/SmartShop_4-676w.4827d451.png";